<div> * {{'Prices do not include VAT'|i18n}}</div>
<ngb-accordion [closeOthers]="true" #acc="ngbAccordion" activeIds="{{userBillingStatus?.activeTab}}">
    <ngb-panel [disabled]="!userBillingStatus?.sumitPaymentsFlag" title="">
        <ng-template ngbPanelTitle>
            <span class="accordingTitle disable_{{userBillingStatus?.sumitPaymentsFlag}}">
                {{'Open Payments'| i18n}}
                ({{userBillingStatus?.sumitPayments?.length ?? 0}})</span>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="paymentTbl">
                <div>
                    {{"The payment is awaiting approval from the credit company"|i18n}}
                </div>

                <!-- bootstrap table display user's payment-->
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">#</th>
                            <th scope="col">{{'Status'|i18n}}</th>
                            <th scope="col">{{'Document Number'|i18n}}</th>
                            <th scope="col">{{'Type'| i18n}} </th>
                            <th scope="col"> {{'Date'| i18n}} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payment of userBillingStatus?.sumitPayments">
                            <td>
                                <div class="loader"></div>

                            </td>
                            <td>{{payment.OGPaymentID}}</td>
                            <td>{{payment.status??'' | i18n}}</td>
                            <td>{{payment.OGDocumentNumber}}</td>
                            <td>{{payment.OGPaymentType}}</td>
                            <td>{{payment.createdAt}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </ngb-panel>

    <ngb-panel title="">
        <ng-template ngbPanelTitle>
            <span class="accordingTitle">
                <span *ngIf="tokenType == 'topUp'"> {{'Buy Tokens'| i18n}} - {{'Left' | i18n}}
                    <span class="numberInline">{{userBillingStatus?.sumTopUps}}</span></span>
                <span *ngIf="tokenType != 'topUp'"> {{'Setup Subscription' | i18n}}
                    <span *ngIf="userBillingStatus?.showCurrentBalance" class="payNowLink">
                        - {{'There is a balance due' | i18n}} {{userBillingStatus?.currentBalance|
                        number:'0.2'}} $
                    </span>

                </span>
            </span>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="links" *ngIf="tokenType == 'topUp'">
                <div *ngFor="let link of userBillingStatus?.topUpLinks">

                    <a [href]="link.url+'?externalidentifier='+userBillingStatus?.token?.owner"
                        [innerHTML]="link.text + ' (Prepaid)'"></a>
                </div>
            </div>
            <div *ngIf="tokenType != 'topUp'">

                <!-- <div class="payNowContainer">
                    <div *ngIf="!userBillingStatus?.showCurrentBalance" class="payNowLink">
                        <div [ngClass]="{'negativeBalance' : userBillingStatus?.currentBalance??0 < 0}"
                            class="payNowLink">
                            <h3>{{'There is no balance due' | i18n}} </h3>
                        </div>
                    </div>

                </div> -->
            </div>
            <div class="paymentMethodsContain">

                <div *ngIf="userBillingStatus?.sumitPaymentMethods?.length" class="paymentMethods">
                    <div>{{'Payment Methods' | i18n}}: </div>
                    <table class="table paymentMethodsTable">

                        <tr *ngFor="let item of userBillingStatus?.sumitPaymentMethods">
                            <td>{{item.CardMask}}</td>
                            <td> {{'Expire' | i18n}}: {{item.ExpirationMonth|
                                number:'0.2'}}/{{item.ExpirationYear}} </td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="!userBillingStatus?.sumitPaymentMethods?.length" class="paymentMethods">
                    <div *ngIf="tokenType != 'topUp'">

                        <div *ngFor="let link of userBillingStatus?.billingLinks">
                            <a class="btn btn-primary"
                                [href]="link.url+'?fixedprice='+userBillingStatus?.totalPrice+'&externalidentifier='+userBillingStatus?.token?.owner">
                                {{'Click here to pay now, and setup monthly subscription' | i18n}}
                                {{userBillingStatus?.totalPrice|
                                number:'0.2'}} $
                            </a>

                        </div>
                        <ul>
                            <li><B>{{"Please pay now to start scanning"|i18n}}</B></li>
                            <li>{{"Subscription charge for remaining days of month"|i18n}}
                                - {{userBillingStatus?.subscriptionPrice|
                                number:'0.2'}} $
                            </li>

                        </ul>
                    </div>

                    <div *ngIf="tokenType == 'topUp'">

                        {{'No Payment Method' | i18n}}
                    </div>

                </div>
                <div *ngIf="tokenType != 'topUp'">

                    {{"Charge for scan"|i18n}}
                    - {{userBillingStatus?.currentBalance|
                    number:'0.2'}} $
                </div>
            </div>

        </ng-template>
    </ngb-panel>
    <ngb-panel title="">
        <ng-template ngbPanelTitle>
            <span class="accordingTitle">{{'Account' | i18n}} - {{userBillingStatus?.sumBills|
                number:'0.2'}}$</span>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="billingTbl">

                <!-- bootstrap table display user's billing-->
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">
                                {{'Price'| i18n}}
                            </th>
                            <th scope="col">
                                {{'Price Including Tax'| i18n}}
                            </th>
                            <th scope="col">
                                {{'Scan'| i18n}}
                            </th>
                            <th scope="col">
                                {{'Subscription'| i18n}}
                            </th>
                            <th scope="col">
                                {{'TopUp'| i18n}}
                            </th>
                            <th scope="col">
                                {{'Date'| i18n}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let bill of userBillingStatus?.bills">
                            <td>
                                <button class="btn btn-primary" (click)="showBillPdf(bill)">
                                    {{bill.Billing_ShovarNumber}}
                                </button>
                            </td>
                            <td>{{bill.amountNoTax|
                                number:'0.2'}}</td>
                            <td>{{bill.amount|
                                number:'0.2'}}</td>
                            <td>{{bill.productPrice | number:'0.2'}}</td>
                            <td>{{bill.subscriptionPrice | number:'0.2'}}</td>
                            <td>{{bill.tokenAmount | number:'0.2'}}</td>
                            <td>{{bill.createdAt}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </ngb-panel>
    <!-- <ngb-panel>
        <ng-template ngbPanelTitle>
            <span>TopUp - {{sumTopUps}}</span>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="topUpTbl">

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">TopUp</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let topUp of topUps">
                            <td>{{topUp.id}}</td>
                            <td>{{topUp.amount}}</td>
                            <td>{{topUp.createdAt}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </ngb-panel> -->
    <!-- <ngb-panel title="Disabled" [disabled]="true">
        <ng-template ngbPanelContent>.
        </ng-template>
    </ngb-panel> -->
</ngb-accordion>